import TcVod from 'vod-js-sdk-v6';
import request from './$x';

// 获取云点播上传签名
/**
 *
 * @param procedure 任务流名称
 * @param classId 分类id
 * @param sourceContext uuid
 * @param type 1 动作库 2 内容 9:功能介绍 15商家素材
 * @returns {function(): Promise<any>}
 */
export async function getVodToken(procedure, classId, sourceContext, type) {
  const sign = await request
    .post(
      '/common/getUploadSignature',
      {
        procedure,
        classId,
        sourceContext,
        type,
      },

      // eslint-disable-next-line consistent-return
    )
    .then(({ code, data }) => {
      if (code === '00000') {
        return data.sign;
      }
    });

  return () => {
    return Promise.resolve(sign);
  };

  // eslint-disable-next-line func-names
  // return function () {
  //   return request(
  //     '/litta-openapi/com.litta.openapi.interfaces.back.MediaManageApi/getUploadSignature',
  //     {
  //       method: 'POST',
  //       data: {
  //         requestData: {
  //           procedure,
  //           classId,
  //           sourceContext,
  //         },
  //       },
  //     },
  //     // eslint-disable-next-line consistent-return
  //   ).then(({ result: { code, data } }) => {
  //     if (code === '00000') {
  //       return data.sign;
  //     }
  //   });
  // };
}

export default function GenerateTcVod(getSignature) {
  return new TcVod({
    getSignature,
  });
}
